const axios = require('axios');

export default async function login(formdata) {
    try {
        const { data } = await axios.post(`${process.env.api}/login`,formdata)
        return { data, error:null };
    } catch (error) {
        return { data:null, error:error };
    }
}